export default "__VITE_ASSET__CgM1hvu0__"